/* eslint-disable sort-keys */
/* eslint-disable no-inline-comments, line-comment-position */
/* eslint-disable @typescript-eslint/naming-convention */

import { InterfaceI18nConfig } from './i18n.interface';

const i18n: InterfaceI18nConfig = {
  inputForm: {
    expanded: false,
    switchFromToIconDescription: {
      de: 'Abfahrts- und Ankunftsort tauschen',
      fr: 'Échanger le lieu de départ et d`arrivée',
      it: 'Scambio di località di partenza e di arrivo',
      en: 'Swap departure and arrival locations',
    },
    buttonExpandedSearch: {
      de: 'Erweiterte Suche',
      fr: 'Recherche avancée',
      it: 'Ricerca avanzata',
      en: 'Advanced search',
    },
    inputErrorMessage: {
      de: 'Feld ist erforderlich',
      fr: 'Le champ est obligatoire',
      it: 'Campo obbligatorio.',
      en: 'This is a required field.',
    },
    searchFormAssistiveLabel: {
      de: 'Fahrplaneingabemaske',
      fr: 'Masque de saisie des horaires',
      it: 'Maschera di inserimento dell`orario',
      en: 'Timetable input mask',
    },
    autocomplete: {
      minChars: 3,
      helpTextUseArrowKeysToNavigate: {
        de: 'Benutzen sie die Pfeiltasten um zwischen den Ergebnissen zu navigieren.',
        fr: 'Utilisez les touches fléchées pour naviguer entre les résultats.',
        it: 'Utilizzare i tasti freccia per spostarsi tra i risultati.',
        en: 'Use the arrow keys to navigate between the results.',
      },
      helpTextResultsAvailable: {
        de: '{x} Resultate verfügbar.',
        fr: '{x} résultats disponibles.',
        it: '{x} Risultati disponibili.',
        en: '{x} Results available.',
      },
      inputPlaceholder: {
        de: 'Name der Haltestelle',
        fr: 'Nom de l`arrêt',
        it: 'Nome della fermata',
        en: 'Name of the stop',
      },
      debounceInputEvent: 400,
    },
    inputFrom: {
      label: {
        de: 'Von',
        fr: 'De',
        it: 'Da',
        en: 'From',
      },
      value: '',
      listAssistiveText: {
        de: 'Liste von Abfahrtsorten',
        fr: 'Liste des lieux de départ',
        it: 'Lista dei luoghi di partenza',
        en: 'List of departure points',
      },
    },
    inputTo: {
      label: {
        de: 'Nach',
        fr: 'À',
        it: 'A',
        en: 'To',
      },
      value: '',
      listAssistiveText: {
        de: 'Liste von Ankunftsorten',
        fr: 'Liste des lieux darrivée',
        it: 'Elenco dei punti di arrivo',
        en: 'List of arrival points',
      },
    },
    date: {
      label: {
        de: 'Datum',
        fr: 'Date',
        it: 'Date',
        en: 'Date',
      },
      value: '',
      iconDescription: {
        de: 'Datumauswahl öffnen',
        fr: 'Ouvrir le choix de la date',
        it: 'Aprire selezione data',
        en: 'Open date selection',
      },
    },
    time: {
      label: {
        de: 'Zeit',
        fr: 'Heure',
        it: 'Ora',
        en: 'Time',
      },
      value: '',
      iconDescription: {
        de: 'Uhrzeitauswahl öffnen',
        fr: 'Ouvrir la sélection de l`heure',
        it: 'Aprire la selezione dell`orario',
        en: 'Open time selection',
      },
    },
    toggleArrivalDeparture: {
      labelArrival: {
        de: 'An',
        fr: 'Arr.',
        it: 'ar',
        en: 'Arr.',
      },
      labelDeparture: {
        de: 'Ab',
        fr: 'Dép.',
        it: 'pt',
        en: 'Dep.',
      },
      description: {
        de: 'Auswahl, ob die Zeit Ankunft oder Abfahrt betrifft.',
        fr: 'Sélection si l`heure concerne l`arrivée ou le départ.',
        it: 'Selezionare se l`orario riguarda l`arrivo o la partenza.',
        en: 'Select whether the time concerns arrival or departure.',
      },
      value: 'ab',
    },
    searchButton: {
      de: 'Verbindung suchen',
      fr: 'Rechercher',
      it: 'Cercare collegamento',
      en: 'Search connection',
    },
    extendedSearch: {
      extended: false,
      deselectAllButton: {
        de: 'Auswahl aufheben',
        fr: 'Supprimer la sélection',
        it: 'Annullare la selezione',
        en: 'Deselect',
      },
      selectAllButton: {
        de: 'Alle auswählen',
        fr: 'Tout sélectionner',
        it: 'Selezionare tutti',
        en: 'Select all',
      },
      via: {
        title: {
          de: 'Via hinzufügen',
          fr: 'Ajouter "via"',
          it: 'Aggiungere via',
          en: 'Add via',
        },
        label: {
          de: 'Via',
          fr: 'Via',
          it: 'Via',
          en: 'Via',
        },
        placeholder: {
          de: 'Name der Haltestelle',
          fr: 'Nom de l`arrêt',
          it: 'Nome della fermata',
          en: 'Name of the stop',
        },
        value: '',
      },
      meansOfTransportation: {
        title: {
          de: 'Verkehrsmittel',
          fr: 'Moyen de transport',
          it: 'Mezzo di trasporto',
          en: 'Transport type',
        },
        name: 'verkehrsmittel',
        inputs: [
          {
            label: {
              de: 'Zug',
              fr: 'Train',
              it: 'Treno',
              en: 'Train',
            },
            value: 'zug', // !! DO NOT CHANGE !!
            checked: true,
          },
          {
            label: {
              de: 'Bus',
              fr: 'Bus',
              it: 'Bus',
              en: 'Bus',
            },
            value: 'bus', // !! DO NOT CHANGE !!
            checked: true,
          },
          {
            label: {
              de: 'Schiff',
              fr: 'Bateau',
              it: 'Battello',
              en: 'Ship',
            },
            value: 'schiff', // !! DO NOT CHANGE !!
            checked: true,
          },
          {
            label: {
              de: 'Standseilbahn',
              fr: 'Funiculaire',
              it: 'Trasporto a fune',
              en: 'Cableway',
            },
            value: 'standseilbahn', // !! DO NOT CHANGE !!
            checked: true,
          },
          {
            label: {
              de: 'Autoreisezug / Extrazug',
              fr: 'Train d`autos accompagnées / train spécial',
              it: 'Treno auto accompagnate / Treno speciale',
              en: 'Car train / Special event train',
            },
            value: 'autoreisezug', // !! DO NOT CHANGE !!
            checked: true,
          },
          {
            label: {
              de: 'Seilbahn / Zahnradbahn',
              fr: 'Funiculaire / Chemin de fer à crémaillère',
              it: 'Funivia / Ferrovia a cremagliera',
              en: 'Funicular / Cog Railway',
            },
            value: 'seilbahn', // !! DO NOT CHANGE !!
            checked: true,
          },
          {
            label: {
              de: 'Kabinenbahn',
              fr: 'Télécabine',
              it: 'Gondola',
              en: 'Gondola',
            },
            value: 'kabinenbahn', // !! DO NOT CHANGE !!
            checked: true,
          },
          {
            label: {
              de: 'Tram / Metro',
              fr: 'Tram / Métro',
              it: 'Tram / Metro',
              en: 'Tramway / Metro',
            },
            value: 'tram', // !! DO NOT CHANGE !!
            checked: true,
          },
        ],
      },
      connections: {
        title: {
          de: 'Verbindungen',
          fr: 'Relations',
          it: 'Collegamenti',
          en: 'Connections',
        },
        name: 'connections',
        inputs: [
          {
            label: {
              de: 'Nur Direktverbindungen',
              fr: 'Liaisons directes uniquement',
              it: 'Solo collegamenti diretti',
              en: 'Direct connections only',
            },
            value: 'direct', // !! DO NOT CHANGE !!
            checked: false,
          },
          {
            label: {
              de: 'Mit Velomitnahme',
              fr: 'Avec transport de vélos',
              it: 'Con il trasporto di biciclette',
              en: 'With bike transport',
            },
            value: 'bike', // !! DO NOT CHANGE !!
            checked: false,
          },
        ],
      },
      a11y: {
        title: {
          de: 'Barrierefreie Verbindung.',
          fr: 'Relation accessible.',
          it: 'Collegamento accessibile a tutti.',
          en: 'Accessible connection.',
        },
        toggleTitle: {
          de: 'Verbindungen für barrierefreies Reisen anzeigen.',
          fr: 'Afficher les trajets permettant de se déplacer sans obstacles.',
          it: 'Mostra i collegamenti per viaggiare senza barriere.',
          en: 'Show connections for accessible travel.',
        },
        name: 'a11y',
        checked: false,
        inputs: [
          {
            label: {
              de: 'Informationen für barrierefreies Reisen für alle Verbindungen anzeigen.',
              fr: 'Afficher les informations sur les trajets accessibles.',
              it: 'Mostra le informazioni per viaggiare senza barriere per tutti i collegamenti.',
              en: 'Show accessible travel information for all connections.',
            },
            value: 'ALL', // !! DO NOT CHANGE !!
            checked: true,
          },
          {
            label: {
              de: 'Nur rollstuhlgängige Verbindungen anzeigen.',
              fr: 'Filtrer par horaires accessibles en fauteuil roulant.',
              it: 'Mostra solo i collegamenti accessibili in sedia a rotelle.',
              en: 'Show only wheelchair-accessible connections.',
            },
            value: 'BOARDING_ALIGHTING_SHUTTLE_TRANSPORT', // !! DO NOT CHANGE !!
            checked: false,
          },
          {
            label: {
              de: 'Nur Verbindungen ohne Shuttle anzeigen.',
              fr: 'Filtrer par horaires sans navette.',
              it: 'Mostra solo i collegamenti senza navetta.',
              en: 'Show only connections without shuttle service..',
            },
            value: 'BOARDING_ALIGHTING_BY_NOTIFICATION', // !! DO NOT CHANGE !!
            checked: false,
          },
          {
            label: {
              de: 'Nur Verbindungen ohne Voranmeldung anzeigen.',
              fr: 'Filtrer par horaires sans annonce préalable.',
              it: 'Mostra solo i collegamenti senza prenotazione.',
              en: 'Show only connections without registration required.',
            },
            value: 'BOARDING_ALIGHTING_BY_CREW', // !! DO NOT CHANGE !!
            checked: false,
          },
          {
            label: {
              de: 'Nur Verbindungen ohne Hilfe anzeigen.',
              fr: 'Filtrer par horaires sans assistance.',
              it: 'Mostra solo i collegamenti senza assistenza.',
              en: 'Show only connections without assistance.',
            },
            value: 'BOARDING_ALIGHTING_SELF', // !! DO NOT CHANGE !!
            checked: false,
          },
        ],
      },
    },
  },
  results: {
    earlierConnections: {
      de: 'Frühere Verbindungen',
      fr: 'Rechercher les relations précedentes',
      it: 'Cercare i collegamenti precedenti',
      en: 'Earlier connections',
    },
    laterConnections: {
      de: 'Spätere Verbindungen',
      fr: 'Rechercher les relations suivantes',
      it: 'Cercare i collegamenti successivi',
      en: 'Later connections',
    },
    buy: {
      default: {
        text: {
          de: 'Ticket kaufen',
          fr: 'Acheter un billet',
          it: 'Acquistare il biglietto',
          en: 'Buy ticket',
        },
        hiddenText: {
          de: 'Ticket kaufen (Absprung zu sbb.ch. Öffnet sich in einem neuen Fenster)',
          fr: 'Acheter un billet (passage à cff.ch. s`ouvre dans une nouvelle fenêtre)',
          it: 'Acquistare il biglietto (passaggio a ffs.ch. si apre in una nuova finestra)',
          en: 'Buy a ticket (jump to sbb.ch. Opens in a new window)',
        },
      },
      withReservation: {
        text: {
          de: 'Tickets & Reservationen',
          fr: 'Billets et réservations',
          it: 'Biglietti e prenotazioni',
          en: 'Tickets & reservations',
        },
        hiddenText: {
          de: 'Ticket und Reservationen kaufen (Absprung zu sbb.ch. Öffnet sich in einem neuen Fenster)',
          fr: 'Acheter des billets et des réservations (renvoi vers cff.ch. s`ouvre dans une nouvelle fenêtre)',
          it: 'Acquistare biglietti e prenotazioni (passaggio a ffs.ch. si apre in una nuova finestra)',
          en: 'Buy tickets and reservations (jump to sbb.ch. Opens in a new window)',
        },
      },
      priceLabel: {
        de: 'Ab CHF {{0}}',
        fr: 'À partir CHF {{0}}',
        it: 'A partire CHF {{0}}',
        en: 'From CHF {{0}}',
      },
    },
    buyLinkUrlParams: [
      {
        key: 'at_medium',
        value: 'affiliate',
      },
      {
        key: 'at_campaign',
        value: 'ktu',
      },
      {
        key: 'at_type',
        value: 'postauto',
      },
    ],
    heading: {
      de: 'Abfahrt: {{1}}, {{2}}{{3}} {{4}}, {{5}}',
      fr: 'Départ: {{1}}, {{2}}{{3}} {{4}}, {{5}}',
      it: 'Partenza: {{1}}, {{2}}{{3}} {{4}}, {{5}}',
      en: 'Departure: {{1}}, {{2}}{{3}} {{4}}, {{5}}',
    },
    storeAndRestoreSearchInUrl: true,
    rows: {
      direction: {
        de: 'Richtung',
        fr: 'Direction',
        it: 'Direzione',
        en: 'Direction',
      },
    },
    journeySummary: {
      assistiveTextDetails: {
        arrival: {
          de: 'Am {date}. Ankunft um {time}.',
          fr: 'Le {date} Arrivée à {time}',
          it: 'Il {date}. Arrivo alle {time}.',
          en: 'On {date}. Arrival at {time}.',
        },
        departure: {
          de: 'Am {date}. Abfahrt um {time}.',
          fr: 'Le {date} Départ à {time}.',
          it: 'Il {date}. Partenza alle {time}.',
          en: 'On {date}. Departure at {time}.',
        },
      },
      assistiveTextTitle: {
        de: 'Resultate zur Fahrplanabfrage: von {origin} nach {destination}.',
        fr: 'Résultats de la consultation des horaires: de {origin} à {destination}.',
        it: 'Risultati della consultazione dell`orario: da {origin} a {destination}.',
        en: 'Results for timetable query: from {origin} to {destination}.',
      },
      changeButtonText: {
        de: 'Suche ändern',
        fr: 'Modifier la recherche',
        it: 'Modificare la ricerca',
        en: 'Change search',
      },
      departureArrival: {
        arrival: {
          de: 'Ankunft',
          fr: 'Arrivée',
          it: 'Arrivo',
          en: 'Arrival',
        },
        departure: {
          de: 'Abfahrt',
          fr: 'Départ',
          it: 'Partenza',
          en: 'Departure',
        },
      },
      headingLevel: 2,
    },
    noResults: {
      headingText: {
        de: 'Zu Ihrer Eingabe konnten keine Verbindungen gefunden werden.',
        fr: 'Aucune correspondance n`a été trouvée.',
        it: 'Non è stato trovato nessun collegamento.',
        en: 'No connection was found for your search.',
      },
      headingLevel: 3,
      description: {
        de: 'Bitte ändern Sie Ihre Eingabe.',
        fr: 'Veuillez modifier votre saisie',
        it: 'Si prega di modificare i dati inseriti.',
        en: 'Please edit your input.',
      },
    },
    hiddenRowSummary: {
      general: {
        de: '{{1}}Abfahrt: {{2}}, {{3}}{{4}}, {{5}}, {{6}}, Ankunft {{7}}, {{8}}{{9}}. {{10}}.',
        fr: '{{1}}Départ: {{2}}, {{3}}{{4}}, {{5}}, {{6}}, Arrivée {{7}}, {{8}}{{9}}. {{10}}.',
        it: '{{1}}Partenza: {{2}}, {{3}}{{4}}, {{5}}, {{6}}, arrivo {{7}}, {{8}}{{9}}. {{10}}.',
        en: '{{1}}Departure: {{2}}, {{3}}{{4}}, {{5}}, {{6}}, arrival {{7}}, {{8}}{{9}}. {{10}}.',
      },
      realtimeInfo: {
        de: 'Echtzeitinformationen: {{1}}{{2}}',
        fr: 'Informations en temps réel: {{1}}{{2}}',
        it: 'Informazioni in tempo reale: {{1}}{{2}}',
        en: 'Real-time information: {{1}}{{2}}',
      },
      travelNotices: {
        de: 'Reisehinweise: {{1}}',
        fr: 'Conseils aux voyageurs: {{1}}',
        it: 'Suggerimenti di viaggio: {{1}}',
        en: 'Travel advice: {{1}}',
      },
      walkTimeDeparture: {
        de: '{{1}} Fussweg vor Abfahrt, ',
        fr: '{{1}} Chemin piéton avant le départ, ',
        it: '{{1}} Sentiero prima della partenza,, ',
        en: '{{1}} walking distance before departure, ',
      },
      walkTimeArrival: {
        de: ', {{1}} Fussweg nach Ankunft',
        fr: '{{1}} Chemin à pied après larrivée',
        it: '{{1}} Sentiero dopo larrivo',
        en: '{{1}} walking distance after arrival',
      },
      discountTickets: {
        de: 'Sparbillete ab {{1}} Franken',
        fr: 'Billets dégriffés dès {{1}} francs',
        it: 'Biglietti risparmio a partire da {{1}} franchi',
        en: 'Supersaver tickets from {{1}} francs',
      },
      tickets: {
        de: 'Tickets ab {{1}} Franken',
        fr: 'Billets dès {{1}} francs',
        it: 'Biglietti a partire da {{1}} franchi',
        en: 'Tickets from {{1}} francs',
      },
      occupancy: {
        firstClass: {
          de: 'Erste Klasse',
          fr: 'Première classe',
          it: 'Prima classe',
          en: 'First class',
        },
        secondClass: {
          de: 'Zweite Klasse',
          fr: 'Deuxième classe',
          it: 'Seconda classe',
          en: 'Second class',
        },
        LOW: {
          de: 'Tiefe bis mittlere Belegung erwartet',
          fr: 'Occupation faible à moyenne attendue',
          it: 'Si prevede un occupazione medio-bassa.',
          en: 'Low to medium occupancy expected',
        },
        MEDIUM: {
          de: 'Hohe Belegung erwartet',
          fr: 'Un taux d occupation élevé est attendu',
          it: 'Ci si aspetta un alta occupazione.',
          en: 'High occupancy expected',
        },
        HIGH: {
          de: 'Sehr hohe Belegung erwartet,',
          fr: 'Taux d occupation très élevé attendu,',
          it: 'Ci si aspetta un occupazione molto elevata,',
          en: 'Very high occupancy expected,',
        },
      },
    },
    legs: {
      footpath: {
        description: {
          de: 'Fussweg',
          fr: 'Parcours à pied',
          it: 'Percorso a piedi',
          en: 'Walk',
        },
        hiddenTextMinutes: {
          de: 'Minuten',
          fr: 'minutes',
          it: 'minuti',
          en: 'minutes',
        },
      },
      wheelchair: {
        noInformation: {
          de: 'Keine Informationen vorhanden',
          fr: 'Aucune information disponible',
          it: 'Nessuna informazione disponibile',
          en: 'No information available',
        },
      },
      hiddenSummary: {
        journeyPartDescription: {
          de: 'Teilstrecke {{1}} von {{2}}',
          fr: 'Section {{1}} de {{2}}',
          it: 'Tratto {{1}} di {{2}}',
          en: 'Section {{1}} from {{2}}',
        },
        title: {
          de: 'Teilstrecke {{1}} von {{2}}',
          fr: 'Section {{1}} de {{2}}',
          it: 'Tratto {{1}} di {{2}}',
          en: 'Section {{1}} from {{2}}',
        },
        realtimeInfoTitle: {
          de: 'Echtzeitinformationen',
          fr: 'Informations en temps réel',
          it: 'Informazioni in tempo reale',
          en: 'Real-time information',
        },
        attributesTitle: {
          de: 'Reisehinweise',
          fr: 'Conseils aux voyageurs',
          it: 'Consigli di viaggio',
          en: 'Travel advice',
        },
        arrival: {
          general: {
            de: 'Ankunft in {{1}} um {{2}}. Ankunft bei {{3}}.',
            fr: 'Arrivée à {{1}} à {{2}}. Arrivée chez {{3}}.',
            it: 'Arrivo a {{1}} alle {{2}}. Arrivo a {{3}}.',
            en: 'Arrival in {{1}} at {{2}}. Arrival at {{3}}.',
          },
          delay: {
            de: 'Aktuelle Ankunftsverspätung {{1}}.',
            fr: 'Retard d`arrivée actuel {{1}}.',
            it: 'Attuale ritardo di arrivo {{1}}.',
            en: 'Current arrival delay {{1}}.',
          },
          a11y: {
            de: 'Rollstuhlzugänglichkeit am Ankunftsbahnhof:',
            fr: 'Accessibilité en fauteuil roulant à la gare d`arrivée:',
            it: 'Accessibilità in sedia a rotelle alla stazione di arrivo:',
            en: 'Wheelchair accessibility at the arrival station:',
          },
        },
        departure: {
          general: {
            de: 'Abfahrt von {{1}} um {{2}} mit {{3}}. Abfahrt ab {{4}}.',
            fr: 'Départ de {{1}} à {{2}} avec {{3}}. Départ à partir du {{4}}.',
            it: 'Partenza da {{1}} alle {{2}} con {{3}} Partenza da {{4}}.',
            en: 'Departure from {{1}} at {{2}} with {{3}}. Departure from {{4}}.',
          },
          delay: {
            de: 'Aktuelle Abfahrtsverspätung {{1}}.',
            fr: 'Retard au départ actuel {{1}}.',
            it: 'Attuale ritardo di partenza {{1}}.',
            en: 'Current departure delay {{1}}.',
          },
          a11y: {
            de: 'Rollstuhlzugänglichkeit am Abfahrtsbahnhof:',
            fr: 'Accessibilité en fauteuil roulant à la gare de départ:',
            it: 'Accessibilità in sedia a rotelle alla stazione di partenza:',
            en: 'Wheelchair accessibility at the departure station:',
          },
        },
      },
    },
    legend: {
      title: {
        de: 'Legende',
        fr: 'Légende',
        it: 'Legenda',
        en: 'Legends',
      },
      titleLevel: 5,
      footnote: {
        de: 'Reiseinformationen gültig vom {{0}} bis {{1}}. Alle Angaben, Anschlüsse und Einhaltung des Fahrplans ohne Gewähr. Informieren Sie sich kurz vor Abfahrt über mögliche Fahrplanänderungen auf <a tabindex="-1" href="https://www.postauto.ch">postauto.ch</a>',
        fr: 'Informations sur le voyage valables du {{0}} au {{1}}. Indications, correspondances et respect de l`horaire non garantis. Veuillez consulter les éventuelles modifications d`horaire sur <a tabindex="-1" href="https://www.carpostal.ch">carpostal.ch</a>',
        it: 'Informazioni di viaggio valide dal {{0}} al {{1}}. Tutte le indicazioni, le coincidenze e il rispetto dell`orario si intendono senza garanzia. Poco prima della partenza, consulta <a tabindex="-1" href="https://www.autopostale.ch">autopostale.ch</a>',
        en: 'Travel information valid from {{0}} until {{1}}. All information, connections and adherence to the timetable are provided without guarantee. Check for possible timetable changes shortly before departure at <a tabindex="-1" href="https://www.postbus.ch">postbus.ch</a>',
      },
    },
    notificationReservation: {
      title: {
        de: 'Information',
        fr: 'Information',
        it: 'Informazione',
        en: 'Information',
      },
      titleLevel: 4,
    },
  },
};

export default i18n;
